import {size, uniq} from 'lodash';

export const options = {
  distance_asc: {
    ordering: 'asc',
    rapidSort: () => ('+distance'),
  },
  date_desc: {
    ordering: 'desc',
    rapidSort: (type) => ({
      sales: '-salesLastSaleContractDate',
      listings: '-salesLastSaleContractDate',
      rentals: '-rentalLastCampaignEndDate',
    }[type]),
  },
  price_asc: {
    ordering: 'asc',
    rapidSort: (type) => ({
      sales: '+salesLastSoldPrice',
      listings: '+salesLastCampaignLastListedPriceDescription',
      rentals: '+rentalLastCampaignLastListedPrice',
    })[type],
  },
  price_desc: {
    ordering: 'desc',
    rapidSort: (type) => ({
      sales: '-salesLastSoldPrice',
      listings: '-salesLastCampaignLastListedPriceDescription',
      rentals: '-rentalLastCampaignLastListedPrice',
    })[type],
  },
  address_asc: {
    ordering: 'asc',
    rapidSort: () => ('+address'),
  },
};

const ComparablesSorter = {
  sortedPropertyIds: (propertyIds, featured, properties) => {
    let uniqPropertyIds = uniq(propertyIds);
    if (size(uniqPropertyIds) > 1) {
      let selectedProperties = uniqPropertyIds.map((id) => properties[id]);
      let selectedFeatured = selectedProperties.filter(p => featured.includes(p.propertyId));
      let selectedNotFeatured = selectedProperties.filter(p => !featured.includes(p.propertyId));
      const sortedProperties = [...selectedFeatured, ...selectedNotFeatured];
      return sortedProperties.map((p) => p.propertyId);
    } else {
      return uniqPropertyIds;
    }
  }
};

export default ComparablesSorter;